export default __webpack_public_path__ + "static/media/SecondLeftBottomEllipse.16ca8c8f.svg";